import * as jQuery from 'jquery';

import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { DeviceDonutComponent } from '../../widgets/device-donut/device-donut.component';

@Component({
	selector: 'app-daily-enagements-v3',
	styleUrls: ['./daily-enagements-v3.component.css'],
	templateUrl: './daily-enagements-v3.component.html'
})
export class DailyEnagementsV3Component extends DeviceDonutComponent implements OnInit, OnDestroy {
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() colors: string;
	@Input() groupby: string;
	@Input() downloadconfig: string;
	@Input() datatableconfig;
	@Input() devicedatatableconfig: string;
	@Input() fields: any;
	@Input() colorsconfig: any;
	@Input() columnsconfig: any;
	@Input() chartconfiguration: any;
	@Input() queryorderby: any;
	@Input() downloadcsvcolumns: any;
	@Input() downloadcsvorderby: any;

	public series: any;
	public chartConfigObj = {
		addSeriesNameToLables: true,
		dataLabelsDistance: 15,
		datalabelsEnabled: false,
		innerSize: 0,
		isTooltipEnabled: true,
		legend: {
			floating: false,
			layout: 'horizontal',
			x: 0,
			y: 5
		},
		lineBreak: true,
		margin: [20, 10, 50, 10],
		seriesName: '',
		showInLegend: true,
		size: '75%',
		svgHeight: 0,
		svgWidth: 0,
		verticalAlign: 'bottom',
		xLegendPos: 15
	};
	public chartConfig;
	public columns: any[];
	public downloadCSVColumns: any;
	public downloadCSVOrderBy: any;
	@ViewChild('chartcontainer', { read: ElementRef }) chartContainer: ElementRef;
	private navigateSlideSubscription;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
		this.navigateSlideSubscription = EmitterService.get(EVENT_EMITTERS.NAVIGATE_TO_SLIDE).subscribe((response: any) => {
			if (response.widget.toLowerCase() === 'daily engagements') {
				this.reload();
			}
		});
		EmitterService.get(EVENT_EMITTERS.SET_ACTIVE_STATE_TO_CURRENT_SLIDE).subscribe((response: any) => {
			if (response.widget.toLowerCase() === 'daily engagements') {
				this.reload();
			}
		});
	}

	ngOnInit(): void {
		this.columns = this.columnsconfig ? JSON.parse(decodeURI(this.columnsconfig)) : [];
		this.chartConfig = JSON.parse(decodeURI(this.chartconfiguration));
		this.devicedatatableconfig = JSON.parse(decodeURI(this.datatableconfig));
		this.fields = JSON.parse(decodeURI(this.fields));
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.downloadconfig = JSON.parse(decodeURI(this.downloadconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.downloadCSVColumns = this.downloadcsvcolumns;
		this.downloadCSVOrderBy = this.downloadcsvorderby;
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
		if (this.navigateSlideSubscription) {
			this.navigateSlideSubscription.unsubscribe();
		}
	}

	reload(): void {
		this.chartConfigObj = {
			...this.chartConfigObj,
			svgHeight: jQuery(this.chartContainer.nativeElement).height() - 80,
			svgWidth: jQuery(this.chartContainer.nativeElement).width() - 40
		};
	}

	processResponseData(responseData: any): void {
		const fieldChartArray: any[] = [];
		for (let j = 0; j < this.fields.length; j++) {
			const chartData: any = { y: 0 };
			chartData.name = this.fields[j].name;
			chartData.color = this.getColorFromColorConfig(j, 1);
			for (const response of responseData) {
				chartData.y += parseFloat(response[this.fields[j].field]);
			}
			if (this.fields[j].type === '%') {
				chartData.y = chartData.y / responseData.length;
			}
			fieldChartArray.push(chartData);
		}
		this.chartConfigObj.seriesName = '';
		this.seriesData = fieldChartArray;
	}

	onResize(event: any): void {
		this.reload();
	}

	private getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}
}
